const c = {
  MetaMask: "metamask",
  WalletConnect: "walletconnect",
  BinanceWallet: "binanceWallet"
};
var a = /* @__PURE__ */ ((n) => (n.accountsChanged = "accountsChanged", n.chainChanged = "chainChanged", n.connect = "connect", n.disconnect = "disconnect", n.message = "message", n))(a || {});
class e {
}
export {
  e as WalletBase,
  a as WalletEvents,
  c as WalletType
};
//# sourceMappingURL=index.mjs.map
